import { COLORS } from './chartColors';
import { sortLabelsChronologically } from './helpers/dateHelpers';
import { parseDataKey } from './helpers/dataHelpers';
import { groupByPeriodAndKey } from './helpers/dataGroupingHelpers';
import { SelectedEntity, JobData, JobRecord } from './helpers/types';

export const jobCountLocationTransformer = (
  data: Record<string, JobData>,
  selectedEntities: SelectedEntity[]
) => {
  // Flatten all records and attach period label from key
  const allRecords: (JobRecord & { _periodLabel: string })[] = [];
  Object.entries(data).forEach(([key, value]) => {
    const { monthLabel, shouldInclude } = parseDataKey(key, selectedEntities);
    if (!shouldInclude) return;
    if (Array.isArray(value.data)) {
      value.data.forEach((record) => {
        allRecords.push({ ...record, _periodLabel: monthLabel });
      });
    }
  });

  // Group by period label and location
  const monthlyLocationCounts = groupByPeriodAndKey(
    allRecords,
    (record) => record._periodLabel,
    (record) => record.location || 'Unknown'
  );

  const allLocations = new Set<string>(allRecords.map((r) => r.location || 'Unknown'));
  const sortedLabels = sortLabelsChronologically(Object.keys(monthlyLocationCounts));

  const datasets = Array.from(allLocations).map((location, index) => ({
    label: location,
    data: sortedLabels.map((label) => monthlyLocationCounts[label][location] || 0),
    backgroundColor: COLORS[index % COLORS.length],
    borderWidth: 1,
    stack: 'jobLocations'
  }));

  return {
    labels: sortedLabels,
    datasets
  };
};
